<div class="login-wrapper">
  <div id="login-container">
    <div class="login-title">Site Management Tool</div>
    <div class="login-subtitle">For Manufacturing</div>
    <button class="em-c-btn" *ngIf="!auth.isAuthenticated()" (click)="auth.login(0)">
      <span class="em-c-btn__text">ExxonMobil Login</span>
    </button>

    <button class="em-c-btn" *ngIf="!auth.isAuthenticated()" (click)="auth.login(1)">
      <span class="em-c-btn__text">Third-Party Login</span>
    </button>

    <button class="em-c-btn" *ngIf="auth.isAuthenticated()" (click)="auth.logout()">
      <span class="em-c-btn__text">Logout</span>
    </button>
  </div>
</div>
